import { Vue, Component } from 'vue-property-decorator'
import StatisticalAnalysisHeader from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.vue'
import {
    StatisticalAnalysisLabeledSampleTagsDossierState,
    initialStatisticalAnalysisLabeledSampleTagsDossierState,
    StatisticalAnalysisSampleTagsDossierModelSearchInfo
} from '@/modules/statistical-analysis-module/views/labeled-samples-dossier/labeled-samples-dossier.model'
import StatisticalAnalysisSidebar from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.vue'
import StatisticalAnalysisViewDetail from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail/statistical-analysis-view-detail.vue'
import { StatisticalAnalysisHeaderNavigationItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { sampleTagsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.service'
import { StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponse, StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponseTags } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.dto'
import StatisticalAnalysisExternalViewSampleTagsStatistics from '@/modules/statistical-analysis-module/components/statistical-analysis-external-views/statistical-analysis-external-views-labeled-sample/statistical-analysis-external-views-labeled-sample.vue'
import StatisticalAnalysisSkeletonLabeledSamplesDossierBase from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-labeled-samples-dossier/statistical-analysis-skeleton-labeled-samples-dossier-base/statistical-analysis-skeleton-labeled-samples-dossier-base.vue'
import { isNil } from 'lodash'

@Component({
    components: {
        StatisticalAnalysisSidebar,
        StatisticalAnalysisHeader,
        StatisticalAnalysisViewDetail,
        StatisticalAnalysisExternalViewSampleTagsStatistics,
        StatisticalAnalysisSkeletonLabeledSamplesDossierBase
    }
})
export default class LabeledSamplesDossier extends Vue {
    state: StatisticalAnalysisLabeledSampleTagsDossierState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisLabeledSampleTagsDossierState()
    }

    get isInitDossier(): boolean {
        return !isNil(this.state.promiseNavigationItems)
    }

    get labeledSampleSelected(): string {
        return this.state.externalInfo.trackingGeneralSelected?.label as string
    }

    get colorSample(): string {
        return this.state.externalInfo.trackingGeneralSelected?.color!
    }

    get sampleLabel(): string {
        return this.state.externalInfo.trackingGeneralSelected?.label!
    }

    onShowItemSelected(itemSelected: StatisticalAnalysisHeaderNavigationItems<number>) {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                trackingGeneralSelected: itemSelected
            }
        }
    }

    onSearch(search: StatisticalAnalysisSampleTagsDossierModelSearchInfo): void {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                startDate: search.startDate,
                endDate: search.endDate,
                typeSearch: search.typeSearch,
                laboratories: search.laboratories,
                grossedProcessedSamples: search.grossedProcessedSamples,
                groupByCase: search.groupByCase,
                states: search.states,
                trackingGeneralSelected: null
            },
            headerData: {
                ...this.state.headerData,
                header: {
                    ...this.state.headerData.header,
                    startDate: search.startDate as Date,
                    endDate: search.endDate as Date,
                    elementType: search.groupByCase ? 'statisticalAnalysis.entities.case' : 'statisticalAnalysis.entities.sample'
                },
                navigationItems: []
            }
        }
        this.state.promiseNavigationItems = this._getGeneralView()
    }

    private async _getGeneralView(): Promise<void> {
        const response = await this.$_toCallSecure(sampleTagsStatisticsDossierService.getGeneralView(this.state.externalInfo))
        this.state.headerData.navigationItems = (response as StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponse).tags?.map((item: StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponseTags) => {
            const navigationItem: StatisticalAnalysisHeaderNavigationItems<number> = {
                icon: 'fal fa-prescription-bottle',
                key: item.sampleTag.id,
                label: item.sampleTag.name,
                value: item.total,
                color: item.sampleTag.color,
                percentage: item.percent
            }
            return navigationItem
        })
        this.state.headerData.header.total = (response as StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponse).total
    }
}
